import {renderErrorPopup} from "../../../../../api/api-popups";
import workspace from "../core/workspace";
import sqftShape from "../core/shapes/sqftShape";
import sqftShapeManager from "../store/sqftShapeManager";

export const renderResetSeamPopup = (shape) => {
  if (shape instanceof sqftShape) {
    shape.setResetSlabModePopupWasDisplayed(true);
    sqftShapeManager.resetShapeChangesInTheSlabMode(shape);

    //state.mouseDown = false;
    //state.mouseDownPosition = null;
    shape.setIsPointsMovable(false);
  }
  renderErrorPopup(workspace.intl.formatMessage({id: "sqft.popup.slab.resetChangesMessage"}))
}

export const shouldResetSlabModePopupOnPointMoveBeDisplayed = (shape) => {
  if (shape instanceof sqftShape
    && (shape.isWithShapePieces()) //|| SlabWorkspace.slabAdditionalShapes.getShapeAdditionalShapes(shape).length > 0
  ) {
    return !shape.getResetSlabModePopupWasDisplayed();
  }

  return false;
}
